
import Vue from 'vue';


Vue.filter('datetime_show', function (value) {
        if (!value) return ''

        if (value == undefined) return '';
        if (value.indexOf("-") <= 0) return value;

        value = value.toString();

        var ar = value.split(' ');
        var pedaco_data = ar[0].split('-');

        var data_saida = pedaco_data[2] + "/" + pedaco_data[1] + "/" + pedaco_data[0] + " " + ar[1];

        return data_saida;
});

Vue.filter('date_show', function (value) {
        if (!value) return ''

        if (value == undefined) return '';

        if (value.indexOf("-") <= 0) return value;

        value = value.toString();

        var ar = value.split(' ');
        var pedaco_data = ar[0].split('-');

        var data_saida = pedaco_data[2] + "/" + pedaco_data[1] + "/" + pedaco_data[0];

        return data_saida;
});


Vue.filter('hora_show', function (value) {
        if (!value) return '';

        if (value == undefined) return '';
        if (value.indexOf("-") <= 0) return value;

        value = value.toString();

        var ar = value.split(' ');
        return ar[1];
});


Vue.filter('nota_final_show', function (value) {
        if (!value) return '0,00';

        var str = parseFloat(value).toFixed(2).toString().replace(".", ",");

        return str;
});


Vue.filter('show_anexo', function (value, folder) {

        return process.env.VUE_APP_URLANEXO + folder + "/" + value;
});